import React from 'react';
import './ContactInfo.css'
import { BiMobileAlt } from "@react-icons/all-files/bi/BiMobileAlt";
import {HiOutlineLocationMarker} from "@react-icons/all-files/hi/HiOutlineLocationMarker";
import {GoMail} from "@react-icons/all-files/go/GoMail";
import emailjs from 'emailjs-com';




const ContactInfo = () => {
    function sendEmail(e) {
        e.preventDefault();
    
        emailjs.sendForm('rafee1100', 'gmail-template', e.target, 'user_VJanLhGiKD7DafBeqSkvF')
          .then((result) => {
              console.log(result.text);
          }, (error) => {
              console.log(error.text);
          });
          e.target.reset();
      }


    return (
        <div className="row mt-3 p-3">
            <div className="col-md-5">
                <div className="d-flex">
                    <div className="m-2 p-0">
                    <BiMobileAlt className="contact-icon"/>
                    </div>
                    <div className="m-2 p-2">
                        <h5>+8801779404301</h5>
                        <p style={{color: 'gray'}}>This is my personal number. You can call me anytime.If not answered Send me a message i will reply soon.</p>
                    </div>
                </div>
                <div className="d-flex">
                    <div className="m-2 p-0">
                    <HiOutlineLocationMarker style={{color: 'blue'}}className="contact-icon"/>
                    </div>
                    <div className="m-2 p-2">
                        <h5>40/5,Matuail Medical Road,Dhaka.</h5>
                        <p style={{color: 'gray'}}>I Live in this apartment with my family. If you ever think to send me a letter send in this address.</p>
                    </div>
                </div>
                <div className="d-flex">
                    <div className="m-2 p-0 ">
                    <GoMail className="contact-icon"/>
                    </div>
                    <div className="m-2 p-2">
                        <h5>rafee.abdullah1@gmail.com</h5>
                        <p style={{color: 'gray'}}>Do mail me at this email if you have any query.I will definitely reply.</p>
                    </div>
                </div>
            </div>
            <div className="col-md-5">
            <h4 className="quality-header text-bold">How Can I help you?</h4>
            <hr style={{width: '9%',height: '2px', color:'blue'}}/>
            <div className="">
            <form onSubmit={sendEmail}>
                <div className="row">
                    <div className="col-md-6">
                        <div class="mb-4">
                            <input type="text" placeholder="Full Name" name="name" class="form-control" id="nameArea"/>
                        </div>
                        <div class="mb-4">
                            
                            <input type="email" placeholder="Email" name="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"/>
                        </div>
                        <div class="mb-4">
                            
                            <input type="text" placeholder="Subject" name="subject" class="form-control" id="Subject"/>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <textarea style={{border: '1px solid lightgray',padding:'4px'}} name="message" placeholder="Message" type="textarea" rows="6" cols="40"></textarea>
                    </div>
                <div>
                </div>                      
                </div>
                <input type="submit" value="Send a Message" class="contact-submit"></input>
                </form>
            </div>
            </div>
        </div>
    );
};

export default ContactInfo;